import _ from 'lodash';

import { IPageComponentForm } from './page-component-form';
import { IPageComponentDto, pageComponentDto } from 'src/assets/common/models/page-component-dto.g';
import { ILevelDomainData } from 'src/app/infrastructure/models/level-domain-data';
import { claimData, ClaimData, IClaimData } from '../../claim/models/claim-data';

export interface IPageComponentCache {
    data: IPageComponentData;
    url: string;
}

export const pageComponentData = {
    requestedDomainUser_nr: 'requestedDomainUser_nr',
    domain_guid: 'domain_guid',

    guid: 'guid',
    nr: 'nr',
    name: 'name',
    normalizedName: 'normalizedName',
    deleted: 'deleted',
    inactive: 'inactive',

    claimsData: 'claimsData',
} as const

export type TPageComponentData = (typeof pageComponentData)[keyof typeof pageComponentData];

export interface IPageComponentData extends ILevelDomainData
{
    [pageComponentData.requestedDomainUser_nr]: number;
    [pageComponentData.domain_guid]: string;

    [pageComponentData.guid]: string;
    [pageComponentData.nr]: number | null;
    [pageComponentData.name]: string | null;
    [pageComponentData.deleted]: boolean;
    [pageComponentData.inactive]: boolean;
    [pageComponentData.claimsData]: ClaimData[] | null;
}

export class PageComponentData
    implements IPageComponentData, ILevelDomainData
{
    [pageComponentData.requestedDomainUser_nr]!: number;
    [pageComponentData.domain_guid]!: string;

    [pageComponentData.guid]!: string;
    [pageComponentData.nr]: number | null = null;
    [pageComponentData.name]: string | null = null;
    [pageComponentData.deleted]!: boolean;
    [pageComponentData.inactive]!: boolean;
    [pageComponentData.claimsData]: ClaimData[] | null = null;

    protected constructor(modelDto?: IPageComponentDto | null);
    protected constructor(modelData: IPageComponentData, modelForm: IPageComponentForm);
    protected constructor(value?: IPageComponentDto | IPageComponentData | null, modelForm?: IPageComponentForm) {
        if (!!modelForm) {
            const _modelData = value as IPageComponentData;
            _.assign(this, _modelData, modelForm);
        } else if (!!value) {
            const _modelDto = value as IPageComponentDto;

            this[pageComponentData.guid] = _modelDto[pageComponentDto.guid]!;
            this[pageComponentData.nr] = _modelDto[pageComponentDto.nr];
            this[pageComponentData.name] = _modelDto[pageComponentDto.name];
            this[pageComponentData.deleted] = _modelDto[pageComponentDto.deleted]!;
            this[pageComponentData.inactive] = _modelDto[pageComponentDto.inactive]!;

            this[pageComponentData.claimsData] = _modelDto[pageComponentDto.claimsDto]
                ?.map(item => ClaimData.create(item))
                .filter((a): a is IClaimData => a !== null)
                .sort((a, b) => (a[claimData.name] ?? '').localeCompare(b[claimData.name] ?? ''))
                ?? null;
        }
    }
        
    static create(modelDto?: IPageComponentDto | null): IPageComponentData | null
    static create(modelData: IPageComponentData, modelForm: IPageComponentForm): IPageComponentData | null
    static create(value?: IPageComponentDto | IPageComponentData | null, modelForm?: IPageComponentForm): IPageComponentData | null {

        if (!!modelForm) {
            const _modelData = value as IPageComponentData;
            return new PageComponentData(_modelData, modelForm);
        } else {
            const _modelDto = value as IPageComponentDto;
            return _modelDto ? new PageComponentData(_modelDto) : null;
        }
    }
}
